const sanitizeHtml = (str) => {
  if (str && typeof str !== "object") return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

  if (!str) return str; // if input is empty string, output is also empty string

  return null; // if input is array or object, output is null
};

export default sanitizeHtml;
